{
  "common": {
    "memberCenter": "会員センター",
    "points": "ポイント",
    "level": "ランク",
    "coupons": "クーポン",
    "checkin": "チェックイン",
    "history": "履歴",
    "balance": "残高",
    "expire": "期限切れ",
    "confirm": "確認",
    "cancel": "キャンセル",
    "loading": "読み込み中...",
    "noData": "データがありません",
    "retry": "再試行",
    "success": "成功",
    "failed": "失敗"
  },
  "points": {
    "earn": "{amount} ポイント獲得",
    "spend": "{amount} ポイント消費",
    "balance": "現在の残高：{amount} ポイント",
    "expired": "{amount} ポイントが期限切れになりました",
    "estimated": "見積もり中（確認待ち）"
  },
  "level": {
    "current": "現在のランク：{name}",
    "nextLevel": "次のランク：{name}",
    "progress": "次のランクまで {current}/{target}",
    "upgraded": "おめでとうございます！{name} にランクアップしました"
  },
  "coupon": {
    "claim": "受け取る",
    "claimed": "受取済み",
    "expired": "期限切れ",
    "used": "使用済み",
    "validUntil": "有効期限：{date}"
  },
  "checkin": {
    "today": "今日のチェックイン",
    "done": "チェックイン済み",
    "streak": "{days} 日連続チェックイン",
    "reward": "+{amount} ポイント"
  },
  "errors": {
    "network": "ネットワークエラー、再試行してください",
    "unauthorized": "ログインしてください",
    "serverError": "サーバーエラー、しばらくしてからお試しください",
    "timeout": "リクエストタイムアウト"
  },
  "ui": {
    "memberCenter": {
      "loading": "読み込み中...",
      "avatarAlt": "会員アバター",
      "pointsBalance": "マイポイント",
      "menuLabel": "会員機能ナビゲーション",
      "menu": {
        "pointsDetail": "ポイント明細",
        "levelDetail": "ランク特典",
        "coupons": "マイクーポン",
        "referral": "友達招待",
        "checkin": "毎日チェックイン"
      }
    },
    "pointsDetail": {
      "title": "ポイント明細",
      "empty": "ポイント履歴がありません",
      "loading": "読み込み中...",
      "noMore": "これ以上ありません",
      "listLabel": "ポイント履歴",
      "status": {
        "pending": "確認待ち",
        "active": "有効",
        "used": "使用済み",
        "expired": "期限切れ"
      }
    },
    "levelProgress": {
      "loading": "読み込み中...",
      "maxLevel": "最高ランク達成",
      "progressLabel": "ランク進捗",
      "noBenefits": "特典がありません",
      "nextLevel": "次のランク：{name}",
      "benefitsTitle": "マイ特典"
    },
    "couponList": {
      "title": "マイクーポン",
      "tabsLabel": "クーポン分類",
      "listLabel": "クーポン一覧",
      "empty": "クーポンがありません",
      "freeShipping": "送料無料",
      "giftValue": "ギフト",
      "discountValue": "{value}% 割引",
      "type": {
        "discount": "割引券",
        "cash": "現金券",
        "shipping": "送料券",
        "gift": "ギフト券"
      },
      "tab": {
        "available": "利用可能",
        "used": "使用済み",
        "expired": "期限切れ"
      }
    },
    "referralShare": {
      "loading": "読み込み中...",
      "title": "友達招待",
      "shareTitle": "友達招待でポイントゲット",
      "shareText": "今すぐ会員登録してプレゼントをゲット！",
      "invitedCount": "招待済み",
      "rewardPoints": "獲得ポイント",
      "codeLabel": "招待コード",
      "linkLabel": "招待リンク",
      "copy": "コピー",
      "copyCode": "招待コードをコピー",
      "share": "シェア",
      "rewardHint": "1人招待で {points} ポイント獲得"
    },
    "checkinCalendar": {
      "loading": "読み込み中...",
      "checking": "チェックイン中...",
      "checkin": "チェックイン",
      "alreadyChecked": "本日チェックイン済み",
      "day": "{count} 日",
      "title": "毎日チェックイン",
      "streak": "{days} 日連続",
      "calendarLabel": "チェックインカレンダー",
      "rewardsTitle": "連続チェックイン特典",
      "rewardsLabel": "特典一覧",
      "weekday": {
        "sun": "日",
        "mon": "月",
        "tue": "火",
        "wed": "水",
        "thu": "木",
        "fri": "金",
        "sat": "土"
      }
    },
    "auth": {
      "login": {
        "emailLabel": "メールアドレス",
        "passwordLabel": "パスワード",
        "submit": "ログイン",
        "createAccount": "アカウント作成",
        "forgotPassword": "パスワードをお忘れですか？",
        "orDivider": "または"
      },
      "register": {
        "emailLabel": "メールアドレス",
        "passwordLabel": "パスワード",
        "confirmPasswordLabel": "パスワード確認",
        "passwordHint": "8文字以上、英字と数字を含む",
        "submit": "アカウント作成",
        "hasAccount": "アカウントをお持ちですか？ログイン",
        "passwordMismatch": "パスワードが一致しません"
      },
      "oauth": {
        "continueWith": "{provider} で続ける"
      },
      "verify": {
        "resend": "コードを再送信",
        "resendCountdown": "再送信（{countdown}秒）"
      },
      "forgot": {
        "title": "パスワードリセット",
        "description": "メールアドレスを入力してください。確認コードをお送りします。",
        "emailLabel": "メールアドレス",
        "submit": "コードを送信",
        "backToLogin": "ログインに戻る"
      }
    }
  },
  "sdk": {
    "error": {
      "211001": "Webhook 署名検証失敗",
      "211003": "Webhook リクエスト重複",
      "211005": "プラットフォーム認証情報が無効",
      "211900": "操作に失敗しました。しばらくしてから再試行してください",
      "211903": "リクエストパラメータが不正です",
      "211909": "ログインまたはセッションを更新してください",
      "211910": "アクセス権限がありません",
      "211911": "会員情報が見つかりません",
      "211912": "アイデンティティの競合、サポートにお問い合わせください",
      "211931": "ランク設定エラー",
      "211933": "ランク特典が利用できません",
      "211951": "ポイント残高不足",
      "211952": "ポイント台帳エラー、サポートにお問い合わせください",
      "211955": "ポイント獲得ルールが未設定",
      "211956": "ポイント差し引きに失敗しました",
      "211957": "ポイントが期限切れです",
      "211958": "ポイント取引の競合、再試行してください",
      "211971": "クーポンが利用できません",
      "211973": "クーポンは既に取得済み",
      "211975": "クーポンが期限切れです",
      "211976": "クーポンは既に使用済み",
      "211991": "サービスが混雑しています、しばらくしてから再試行してください",
      "network": "ネットワークエラー、接続を確認してください",
      "timeout": "リクエストタイムアウト、再試行してください",
      "aborted": "リクエストはキャンセルされました",
      "parse": "レスポンス解析エラー",
      "unauthorized": "ログインしてください",
      "config": "SDK 初期化エラー",
      "unknown": "不明なエラーが発生しました"
    }
  }
}
